import { Branch } from "../types/branch";
import { useBranchData } from "./useBranchData";
import { useUpdateVisibility } from "./useUpdateVisibility";
import { useBranchUpdate } from "./useBranchUpdate";
import { useState } from "react";

export const useEditBranch = (
  id: string,
  formData: any,
  getdata: Branch | undefined,
  doberror: boolean,
  error: string,
  updateFormData: (data: Partial<any>) => void,
  closeEdit: () => void,
  fetchBranches: () => void
) => {
  const branchData = useBranchData(id, updateFormData);
  const visible = useUpdateVisibility(formData, branchData, error, doberror);

  const [dateDirty, setDateDirty] = useState(false);

  const { loading, updateBranch: originalUpdateBranch } = useBranchUpdate( id, formData, closeEdit, fetchBranches, dateDirty );

  const updateBranch = () => { originalUpdateBranch(); };

  return { loading, visible, updateBranch, setDateDirty };
};
